import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { BaseRepository } from '../../Common/Data/base.repository';
import { Observable } from 'rxjs';

@Injectable()
export class GetLogFilesRepository extends BaseRepository {
    constructor(httpClient: HttpClient) {
        super(httpClient);
    }

    getLogFileLocationList(): Observable<Core.LogFileLocationViewModel[]> {
        return this.httpGet('/api/diagnostics/logFile/getFileLocations');
    }

    getLogFileList(searchModel: Core.LogFileLocationViewModel): Observable<number> {
        return this.httpPost('/api/diagnostics/logFile/getFileList', searchModel);
    }

    downloadLogFile(file: Core.LogFileViewModel): Observable<number> {
        return this.httpPost('/api/diagnostics/logFile/logFileDownload', file);
    }

    getDownloadLogFile(longRunningProcessId: number): Observable<HttpResponse<Blob>> {
        const options = {
            observe: 'response',
            responseType: 'blob',
        };
        return this.httpGet(`/api/diagnostics/logFile/getDownloadLogFile/${longRunningProcessId}`, options);
    }
}
